import request from '@/utils/request'


// 查询用户账户列表
export function listAccount(query) {
  return request({
    url: '/biz/user-account/list',
    method: 'get',
    params: query
  })
}

// 查询用户账户分页
export function pageAccount(query) {
  return request({
    url: '/biz/user-account/page',
    method: 'get',
    params: query
  })
}

// 查询用户账户详细
export function getAccount(data) {
  return request({
    url: '/biz/user-account/detail',
    method: 'get',
    params: data
  })
}

// 新增用户账户
export function addAccount(data) {
  return request({
    url: '/biz/user-account/add',
    method: 'post',
    data: data
  })
}

// 修改用户账户
export function updateAccount(data) {
  return request({
    url: '/biz/user-account/edit',
    method: 'post',
    data: data
  })
}

// 删除用户账户
export function delAccount(data) {
  return request({
    url: '/biz/user-account/delete',
    method: 'post',
    data: data
  })
}
